export default (_key) => {
	try{
		return JSON.parse(window?.localStorage?.getItem(`${_key}`))
	}catch(e){
		console.log(e)
	}
};
